// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"a2450390","312":"d941cb2d","442":"4d3ea847"}[chunkId] + ".chunk.css";
};